import React from 'react'
import WhatIsLevyLiability from '../content/what-is-levy-liability.mdx'
import SectionTitle from '../components/section-title'
import QuestionButton from '../components/question-button'
import Table, { ITableRowData } from '../components/table'
import Dialog from './dialog'
import { getLevyTableData } from '../utils/derivedData'
import { SmallMobileDeviceWidth } from '../lib/constants'

interface IProps {
  parcelsSelected: string[]
  parcelSpi?: string
  parcelData: any
  parcelAggregates: any
  areaData: any
  rates: any
  showDetailedTable?: boolean
  filterZeros?: boolean
  showHelp?: boolean
  titleFontSizePx?: string
}

interface IState {
  levyHelpOpen: boolean
}

const LevyLiability = class extends React.Component<IProps, IState> {
  static defaultProps: { showDetailedTable: boolean; showHelp: boolean }

  state = {
    levyHelpOpen: false
  }

  setLevyHelpState = (open: boolean) => {
    this.setState(() => ({
      levyHelpOpen: open
    }))
  }

  render() {
    const {
      parcelsSelected,
      parcelSpi,
      parcelData,
      parcelAggregates,
      areaData,
      rates,
      showDetailedTable,
      filterZeros,
      showHelp,
      titleFontSizePx
    } = this.props
    const { levyHelpOpen } = this.state

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const smallMobile = vw <= SmallMobileDeviceWidth
    let liabilityHeaders = ['Habitat type', 'Area / locations']
    if (showDetailedTable) {
      if (!smallMobile) liabilityHeaders = liabilityHeaders.concat(['Applicable rate'])
      liabilityHeaders = liabilityHeaders.concat(['Estimated subtotal'])
    }
    const liabilityRows: ITableRowData[] = getLevyTableData(
      parcelsSelected,
      parcelAggregates,
      areaData,
      rates,
      parcelSpi,
      parcelData,
      showDetailedTable,
      filterZeros,
      smallMobile
    )

    return (
      <>
        <SectionTitle title="Levy liability" titleFontSizePx={titleFontSizePx}>
          {showHelp && <QuestionButton onClick={() => this.setLevyHelpState(true)} />}
          <Dialog open={levyHelpOpen} setPopupState={this.setLevyHelpState} heading="What is a levy liability?">
            <WhatIsLevyLiability />
          </Dialog>
        </SectionTitle>
        {liabilityRows.length ? (
          <Table headers={liabilityHeaders} rows={liabilityRows} fixed={smallMobile} />
        ) : (
          <p>None</p>
        )}
      </>
    )
  }
}

LevyLiability.defaultProps = {
  showDetailedTable: false,
  showHelp: true
}

export default LevyLiability
